import type { FunctionComponent } from "react";
import {
  SkeletonLoader,
  StatusTag,
  StatusTagStatus,
} from "@kanda-libs/ks-design-library";
import useJobStatusProps from "components/job/JobLayout/JobStatus/useJobStatusProps";
import { CLASS_NAMES } from "components/job/JobLayout/JobStatus/constants";
import { SKELETON_PROPS } from "../JobFinanceStatus/constants";

export interface JobStatusProps {}

const JobStatus: FunctionComponent<JobStatusProps> = function () {
  const { archived, status, timestamp, isLoading } = useJobStatusProps();

  return (
    <SkeletonLoader
      {...SKELETON_PROPS}
      isLoading={isLoading}
      afterLoading={
        <StatusTag
          status={(archived ? "archived" : status) as StatusTagStatus}
          timestamp={timestamp as unknown as number}
          size={28}
          variant="solid"
          className={CLASS_NAMES.statusTag}
        />
      }
    />
  );
};

export default JobStatus;
